import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toast_ic_error",
  "use": "icon-toast_ic_error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-toast_ic_error\">\n<style type=\"text/css\">\n\t#icon-toast_ic_error .st0{fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M12,23C5.935,23,1,18.065,1,12S5.935,1,12,1s11,4.935,11,11S18.065,23,12,23z M12,3c-4.962,0-9,4.038-9,9\n\t\tc0,4.963,4.038,9,9,9c4.963,0,9-4.037,9-9C21,7.038,16.963,3,12,3z\" />\n</g>\n<path class=\"st0\" d=\"M13.414,12l2.293-2.293c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L9.707,8.293\n\tc-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-2.293,2.293c-0.391,0.391-0.391,1.023,0,1.414\n\tC8.488,15.902,8.744,16,9,16s0.512-0.098,0.707-0.293L12,13.414l2.293,2.293C14.488,15.902,14.744,16,15,16s0.512-0.098,0.707-0.293\n\tc0.391-0.391,0.391-1.023,0-1.414L13.414,12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/toast_ic_error.svg
// module id = 7m5k
// module chunks = 87